import { compile } from 'vue-template-compiler';

export default [
    {
        path: "/",
        name: "首页",
        component: () => import('../views/home'),
    },
    {
        path: "/about",
        // name: "关于我们",
        component: () => import('../views/wrapper'),
        children: [
            {
                path: '',
                name: '关于我们 - 首页',
                component: () => import('../views/about/about'),
            },
            {
                path: "more",
                name: "关于我们 - 更多",
                component: () => import('../views/about/more'),
            },
        ]
    },
    {
        path: "/contactUs",
        name: "联系我们",
        component: () => import('../views/contactUs'),
    },
    {
        path: '/talents',
        component: () => import('../views/talents/talents'),
        children: [
            {
                path: '',
                component: () => import('../views/talents/menu'),
                children: [
                    // {
                    //     path: '',
                    //     redirect: 'star', //重定向
                    // },
                    {
                        path: 'museum',
                        name: '博物馆',
                        component: () => import('../views/talents/museum'),
                    },
                    {
                        path: 'star',
                        name: '娱乐艺人列表',
                        component: () => import('../views/talents/starList'),
                    },
                    {
                        path: 'artist',
                        name: '艺术家列表',
                        component: () => import('../views/talents/artistList'),
                    },
                    {
                        path: 'images',
                        name: '艺术家图组',
                        component: () => import('../views/talents/artistImages'),
                    },
                    {
                        path: 'ip',
                        name: '形象ip列表',
                        component: () => import('../views/talents/artistList'),
                    },
                    {
                        path: 'ipDetail',
                        name: '形象ip详情',
                        component: () => import('../views/talents/ipDetail'),
                    },
                    {
                        path: 'theme',
                        name: '主题列表',
                        component: () => import('../views/talents/themeList'),
                    },
                ]
            },
            {
                path: 'qa',
                name: '常见问题',
                component: () => import('../views/talents/qa'),
            },
        ]
    },
    {
        path: "/news",
        component: () => import('../views/wrapper'),
        children: [
            {
                path: '',
                name: "新闻-首页",
                component: () => import('../views/news/news'),
            },
            {
                path: 'detail',
                name: "新闻-详情",
                component: () => import('../views/news/detail'),
            },
        ]
    },
    {
        path: '/study',
        // name: '学习',
        component: () => import('../views/study/study'),
        children: [
            {
                path: '',
                // name: '菜单',
                component: () => import('../views/study/menu'),
                children: [
                    {
                        path: '',
                        name: '学习-全部',
                        component: () => import('../views/study/all'),
                    },
                    {
                        path: 'list',
                        name: '学习-其他列表',
                        component: () => import('../views/study/list'),
                    },
                ]
            },
            {
                path: 'detail',
                name: '学习-详情',
                component: () => import('../views/study/detail'),
            },
        ]
    },
    {
        path: '/shop',
        // name: '商店',
        component: () => import('../views/shop/shop'),
        children: [
            {
                path: '',
                name: '商店-首页',
                component: () => import('../views/shop/home'),
            },
            {
                path: 'category',
                // name: '商店-分类首页',
                component: () => import('../views/wrapper'),
                children: [
                    {
                        path: '',
                        redirect: '/shop', //重定向
                    },
                    {
                        path: ':id',
                        // name: '商店-分类首页',
                        component: () => import('../views/wrapper'),
                        children: [
                            {
                                path: '',
                                name: '商店-分类首页',
                                component: () => import('../views/shop/home'),
                            },
                            {
                                path: 'filter',
                                name: '商店-筛选',
                                component: () => import('../views/shop/filter'),
                            },
                        ]
                    },
                ]
            },
            {
                path: 'detail',
                name: '商店-详情',
                component: () => import('../views/shop/detail'),
            }
        ]
    },
    {
        path: '/gallery',
        // name: '画廊',
        component: () => import('../views/gallery/gallery'),
        children: [
            {
                path: '',
                name: '画廊-首页',
                component: () => import('../views/gallery/home'),
            },
            {
                path: 'exhibition',
                // name: '画廊-展览',
                component: () => import('../views/wrapper'),
                children: [
                    {
                        path: '',
                        name: '画廊-展览',
                        component: () => import('../views/gallery/exhibition'),
                    },
                    {
                        path: 'detail',
                        name: '画廊-展览-详情',
                        component: () => import('../views/gallery/detail'),
                    },
                    {
                        path: 'join',
                        name: '画廊-展览-预约',
                        meta: {
                            requiresAuth: true
                        },
                        component: () => import('../views/gallery/join'),
                    }
                ]
            },
            {
                path: 'artist',
                // name: '画廊-艺术家',
                component: () => import('../views/wrapper'),
                children: [
                    {
                        path: '',
                        name: '画廊-艺术家',
                        component: () => import('../views/gallery/artist'),
                    },
                    {
                        path: 'detail',
                        name: '画廊-艺术家-详情',
                        component: () => import('../views/gallery/artistDetail'),
                    }
                ]
            },
            {
                path: 'works',
                // name: '画廊-作品总览',
                component: () => import('../views/wrapper'),
                children: [
                    {
                        path: '',
                        name: '画廊-作品总览',
                        component: () => import('../views/gallery/works'),
                    },
                    {
                        path: 'detail',
                        name: '画廊-作品总览-详情',
                        component: () => import('../views/gallery/worksDetail'),
                    }
                ]
            },
            {
                path: 'latestNews',
                // name: '画廊-最新消息',
                component: () => import('../views/wrapper'),
                children: [
                    {
                        path: '',
                        name: '画廊-最新消息',
                        component: () => import('../views/gallery/news'),
                    },
                    {
                        path: 'detail',
                        name: '画廊-最新消息-详情',
                        component: () => import('../views/gallery/detail'),
                        // component: () => import('../views/gallery/newsDetail'),
                    },
                    {
                        path: 'join',
                        name: '画廊-最新消息-预约',
                        meta: {
                            requiresAuth: true
                        },
                        component: () => import('../views/gallery/join'),
                    }
                ]
            },
            {
                path: 'activities',
                // name: '画廊-跨界活动',
                component: () => import('../views/wrapper'),
                children: [
                    {
                        path: '',
                        name: '画廊-跨界活动',
                        component: () => import('../views/gallery/activities'),
                    },
                    {
                        path: 'detail',
                        name: '画廊-跨界活动-详情',
                        component: () => import('../views/gallery/detail'),
                    },
                    {
                        path: 'join',
                        name: '画廊-跨界活动-预约',
                        meta: {
                            requiresAuth: true
                        },
                        component: () => import('../views/gallery/join'),
                    }
                ]
            },
            {
                path: 'online',
                // name: '画廊-线上展厅',
                component: () => import('../views/wrapper'),
                children: [
                    {
                        path: '',
                        name: '画廊-线上展厅',
                        component: () => import('../views/gallery/online'),
                    },
                    {
                        path: 'detail',
                        name: '画廊-线上展厅-详情',
                        component: () => import('../views/gallery/detail'),
                    },
                    {
                        path: 'join',
                        name: '画廊-线上展厅-预约',
                        meta: {
                            requiresAuth: true
                        },
                        component: () => import('../views/gallery/join'),
                    }
                ]
            },
            {
                path: 'about',
                name: '画廊-关于画廊',
                component: () => import('../views/gallery/about'),
            },
        ]
    },
    {
        path: '/terms',
        name: '服务条款',
        component: () => import('../views/terms'),
    },
    {
        path: '/copyright',
        name: '版权信息',
        component: () => import('../views/copyright'),
    },
    {
        path: '/privacyPolicy',
        name: '隐私政策',
        component: () => import('../views/privacyPolicy'),
    },
    {
        path: '/login',
        name: '登录',
        component: () => import('../views/mine/login'),
    },
    {
        path: '/register',
        name: '注册',
        component: () => import('../views/mine/register'),
    },
    {
        path: '/shopping',
        // name: '购物车',
        meta: {
            // requiresAuth: true
        },
        component: () => import('../views/shopping/shopping'),
        // component: () => import('../views/wrapper'),
        children: [
            {
                path: '',
                name: '购物车',
                component: () => import('../views/shopping/list'),
            },
            {
                path: 'order',
                name: '下订单',
                component: () => import('../views/shopping/order'),
            },
            {
                path: 'pay',
                name: '支付',
                component: () => import('../views/shopping/pay'),
            },
        ]
    },
    {
        path: '/vip',
        // name: '会员',
        component: () => import('../views/vip/vip'),
        children: [
            {
                path: '',
                redirect: 'exhibition',
            },
            {
                path: 'exhibition',
                // name: '会员 - 无限展览',
                component: () => import('../views/wrapper'),
                children: [
                    {
                        path: '',
                        name: '会员 - 无限展览',
                        component: () => import('../views/vip/exhibition'),
                    },
                    {
                        path: 'buy',
                        name: '会员 - 购买会员',
                        component: () => import('../views/vip/buy'),
                    },
                ]
            }
        ]
    },
    {
        path: '/mine',
        component: () => import('../views/mine/mine'),
        children: [
            {
                path: '',
                redirect: 'userinfo'
            },
            {
                path: 'userinfo',
                name: '用户信息',
                component: () => import('../views/mine/userinfo'),
            },
            {
                path: 'updataPwd',
                name: '修改密码',
                component: () => import('../views/mine/updataPwd'),
            },
            {
                path: 'order',
                // name: '我的订单',
                // component: () => import('../views/mine/order'),
                component: () => import('../views/wrapper'),
                children: [
                    {
                        path: '',
                        name: '我的订单-列表',
                        component: () => import('../views/mine/order'),
                    },
                    {
                        path: 'afterSale',
                        name: '我的订单-售后',
                        component: () => import('../views/mine/afterSale'),
                    }
                ]
            },
            {
                path: 'invoice',
                name: '我的发票',
                component: () => import('../views/mine/invoice'),
            },
            {
                path: 'address',
                name: '收货地址',
                component: () => import('../views/mine/address'),
            },
            {
                path: 'refund',
                name: '退款管理',
                component: () => import('../views/mine/refund'),
            },
        ]
    },
    // {
    //     path: '/',
    //     redirect: '/home', //重定向
    // },
    // {
    //     path: '/home',
    //     name: '',
    //     component: () => import('../views/container'),
    //     children: [
    //         {
    //             path: '',
    //             name: '首页',
    //             component: () => import('../views/home/index'),
    //         },
    //         {
    //             path: 'interactiveMessageDetail',
    //             name: '互动留言详情',
    //             meta: {
    //                 requiresAuth: true,
    //                 title: '互动留言'
    //             },
    //             // redirect: '/none'
    //             component: () => import('../views/home/interactiveMessageDetail'),
    //         },
    //     ]
    // },
]
